import { COOKIES } from "src/context/constants";
import { loggedInBrokerUsernamesType } from "src/types/broker-types";
import useCookie from "./useCookie"

const useBrokerFromCookie = () => {
    const { getCookie, setCookie } = useCookie();
    
    const getBrokerUsernameFromCookie = () => {
      let loggedInBrokerUsernamesCookie = getCookie(COOKIES.loggedInBrokerUsername)
      if (typeof loggedInBrokerUsernamesCookie !== "string") return {}
      // let loggedInBrokerUsernamesCookieAscii = Buffer.from(loggedInBrokerUsernamesCookie,"base64").toString("ascii")
      let loggedInBrokerUsernamesCookieAscii = decodeURIComponent(loggedInBrokerUsernamesCookie)
      let loggedInBrokerUsernames:loggedInBrokerUsernamesType = JSON.parse(loggedInBrokerUsernamesCookieAscii)
      return loggedInBrokerUsernames
    }

    const saveBrokerUsernameToCookie = (brokerUsername:loggedInBrokerUsernamesType) => {{
      let loggedInBrokerUsernamesString = JSON.stringify(brokerUsername)
      // let loggedInBrokerUsernamesStringBase64 =  Buffer.from(loggedInBrokerUsernamesString).toString("base64")
      let loggedInBrokerUsernamesStringBase64 =  encodeURIComponent(loggedInBrokerUsernamesString)
      setCookie(COOKIES.loggedInBrokerUsername,loggedInBrokerUsernamesStringBase64,7)
    }}

    const addBrokerUsernameToCookie = (brokerName:string,brokerUsername:string) => {
      const brokerUsernameFromCookie = getBrokerUsernameFromCookie()
      if (typeof brokerUsernameFromCookie === "undefined") return
      brokerUsernameFromCookie[brokerName.toLowerCase()] = brokerUsername
      saveBrokerUsernameToCookie(brokerUsernameFromCookie)
    }

    const delBrokerUsernameFromCookie = (brokerName?:string) => {
      const brokerUsernameFromCookie = getBrokerUsernameFromCookie()
      if (typeof brokerUsernameFromCookie === "undefined") return
      if (!brokerName) return
      delete brokerUsernameFromCookie[brokerName.toLowerCase() ]
      saveBrokerUsernameToCookie(brokerUsernameFromCookie)
    }

    return {
      getBrokerUsernameFromCookie,
      saveBrokerUsernameToCookie,
      addBrokerUsernameToCookie,
      delBrokerUsernameFromCookie,
    }
}

export default useBrokerFromCookie